import { create } from 'zustand';
import { pickBugcheck, type Bugcheck } from './bugcheck';

interface CrashStore {
  /** The stop screen currently up, or null while the machine is well. */
  bugcheck: Bugcheck | null;
  /** Bring the machine down. Ignored if it is already down. */
  crash(check?: Bugcheck): void;
}

/**
 * Whether the machine has fallen over, kept outside the window manager for the
 * same reason the shutdown phase is: it outranks every window at once.
 *
 * Not persisted, and it does not need to be — the only way out of a stop
 * screen is a reboot, and a reboot is a page load.
 */
export const useCrashStore = create<CrashStore>((set, get) => ({
  bugcheck: null,
  crash: (check) => {
    if (get().bugcheck) return;
    set({ bugcheck: check ?? pickBugcheck() });
  },
}));
